{
	"filterError": "O array de fields não pode ter mais de 4 itens.",
	"perDay": "Por dia",
	"byPeriod": "Por período",
	"news": "Novidades"
}
